import React, { useEffect, useState } from 'react'
import CardValores from './CardValores'

export default function ValoresCupos (props) {
  const { asignados, descargados } = props
  const [porcentajeDescarga, setProcentajeDescarga] = useState(0)

  useEffect(() => {
    const porcentaje = asignados > 0 ? Math.min(100, Math.round((descargados / asignados) * 100)) : null
    setProcentajeDescarga(porcentaje)
  }, [asignados, descargados])

  const renderCantidad = () => {
    return `${asignados} - ${descargados}`
  }

  return (
    <CardValores
      titulo={'Cupos asignados / Descargados'}
      cantidad={renderCantidad()}
      porcentaje={porcentajeDescarga}
      cardColor={'#835f91'}
    />
  )
}
